import { PrivateTransfersSuccessModal } from "./PrivateTransferSuccessModal";
import { PublicTransfersSuccessModal } from "./PublicTransferSuccessModal";
import type { TransferTxSuccess } from "./transfersConfig";

export function TransfersSuccessModal({
  isOpen,
  onClose,
  transferResult,
}: {
  isOpen: boolean;
  onClose: () => void;
  transferResult: TransferTxSuccess | null;
}) {
  if (!transferResult) {
    return null;
  }

  if (transferResult.transferMode === "private") {
    return <PrivateTransfersSuccessModal isOpen={isOpen} onClose={onClose} transferResult={transferResult} />;
  }

  return <PublicTransfersSuccessModal isOpen={isOpen} onClose={onClose} transferResult={transferResult} />;
}
